import {
  DEVICE_FILTER,
  INPUT,
} from 'pages/Assets/components/DevicesDatagrid/components/DeviceFilters/constants';

export const ASSET_MODEL_INPUT_ID = `${DEVICE_FILTER}asset-model-${INPUT}`;
